module.exports = __webpack_public_path__ + "static/SourceSansPro-Light-f6e665a72ff25c83e9e0a02f59e5170b.woff2";